import theme from '../../theme';
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const PROCESS_CSS = `
  .scroll-progress-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    z-index: 1200;
    pointer-events: none;
  }
  .scroll-progress-bar {
    height: 100%;
    background-color: ${theme.gold};
    width: 0%;
    transition: width 0.1s ease-out;
    box-shadow: 0 0 8px rgba(184, 149, 90, 0.6);
  }
  .process-wrapper {
    max-width: 760px;
    margin: 0 auto;
    padding: 48px 24px;
  }
  .process-breadcrumb {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    margin-bottom: 24px;
    color: ${theme.textMuted};
  }
  .breadcrumb-link {
    color: ${theme.textMuted};
    text-decoration: none;
    transition: color 0.15s;
  }
  .breadcrumb-link:hover {
    color: ${theme.gold};
  }
  .breadcrumb-separator {
    margin: 0 8px;
    color: rgba(184, 149, 90, 0.3);
  }
  .breadcrumb-current {
    color: ${theme.textPrimary};
    font-weight: 400;
  }
  
  .process-card {
    background-color: ${theme.bgDark};
    border: 1px solid rgba(184, 149, 90, 0.25);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    padding: 56px 48px;
    position: relative;
    border-radius: 2px;
    margin-top: 8px;
  }
  .process-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    background:
      radial-gradient(circle at 50% 50%, rgba(var(--ap-text-primary-rgb), 0.015) 1px, transparent 1px),
      radial-gradient(circle at 0 0, rgba(var(--ap-text-primary-rgb), 0.008) 1px, transparent 1px);
    background-size: 8px 8px, 12px 12px;
    opacity: 0.9;
    border-radius: 2px;
  }

  .process-header {
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(184, 149, 90, 0.2);
  }
  .process-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 38px;
    font-weight: 400;
    color: ${theme.textPrimary};
    line-height: 1.25;
    margin: 0;
    letter-spacing: 0.01em;
  }
  
  /* Metadata info */
  .process-meta {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${theme.gold};
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  /* Audio player styling */
  .audio-player-container {
    background: rgba(var(--ap-bg-dark-rgb), 0.7);
    border: 1px solid rgba(184, 149, 90, 0.2);
    border-radius: 4px;
    padding: 16px 20px;
    margin: 24px 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.3);
    position: relative;
    z-index: 5;
  }
  .audio-player-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 190px;
  }
  .audio-play-button {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    border: 1px solid rgba(184, 149, 90, 0.4);
    background: transparent;
    color: ${theme.gold};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    outline: none;
  }
  .audio-play-button:hover {
    background: rgba(184, 149, 90, 0.1);
    border-color: ${theme.gold};
    color: ${theme.textPrimary};
    transform: scale(1.05);
  }
  .audio-play-icon {
    width: 18px;
    height: 18px;
  }
  .audio-player-info {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  .audio-player-title {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: ${theme.textPrimary};
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .audio-player-narrator {
    font-family: 'Cormorant Garamond', serif;
    font-size: 13px;
    color: ${theme.textMuted};
    font-style: italic;
  }
  .audio-player-center {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .audio-timeline-wrapper {
    position: relative;
    width: 100%;
    height: 4px;
    background: rgba(var(--ap-text-primary-rgb), 0.1);
    border-radius: 2px;
  }
  .audio-timeline-slider {
    position: absolute;
    top: -6px;
    left: 0;
    width: 100%;
    height: 16px;
    background: transparent;
    -webkit-appearance: none;
    appearance: none;
    outline: none;
    z-index: 10;
    margin: 0;
  }
  .audio-timeline-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${theme.gold};
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0,0,0,0.6);
    border: 1px solid rgba(13, 27, 46, 0.8);
    transition: transform 0.1s ease;
  }
  .audio-timeline-slider::-webkit-slider-thumb:hover {
    transform: scale(1.3);
  }
  .audio-timeline-slider::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border: 1px solid rgba(13, 27, 46, 0.8);
    border-radius: 50%;
    background: ${theme.gold};
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0,0,0,0.6);
    transition: transform 0.1s ease;
  }
  .audio-timeline-slider::-moz-range-thumb:hover {
    transform: scale(1.3);
  }
  .audio-timeline-fill {
    height: 100%;
    background: ${theme.gold};
    border-radius: 2px;
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
  .audio-player-right {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 80px;
    justify-content: flex-end;
  }
  .audio-time {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 12px;
    color: ${theme.textMuted};
  }
  .audio-time-separator {
    font-family: 'Josefin Sans', sans-serif;
    font-size: 12px;
    color: rgba(var(--ap-text-muted-rgb), 0.3);
  }

  /* Drop Cap Style */
  .process-body p:first-of-type::first-letter {
    font-family: 'Cormorant Garamond', 'EB Garamond', serif;
    font-size: 4rem;
    line-height: 0.85;
    float: left;
    margin-top: 6px;
    margin-right: 12px;
    margin-bottom: 2px;
    color: ${theme.gold};
    font-weight: 400;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  }

  /* Pullquote Style */
  .process-pullquote {
    font-family: 'Cormorant Garamond', serif;
    font-size: 23px;
    line-height: 1.6;
    color: ${theme.gold};
    font-style: italic;
    margin: 44px 0;
    padding: 0 40px;
    border-left: 2px solid rgba(184, 149, 90, 0.4);
    position: relative;
    text-align: left;
    box-sizing: border-box;
  }
  .process-pullquote::before {
    content: '“';
    font-family: 'Cormorant Garamond', serif;
    font-size: 80px;
    color: rgba(184, 149, 90, 0.08);
    position: absolute;
    left: 12px;
    top: -36px;
    line-height: 1;
  }

  .process-body {
    font-family: 'Cormorant Garamond', 'EB Garamond', serif;
    font-size: 19.5px;
    line-height: 1.85;
    color: ${theme.textPrimary};
  }
  .process-body p {
    margin: 0 0 1.7em;
    text-align: justify;
    text-justify: inter-word;
  }
  .process-heading {
    font-family: 'Josefin Sans', sans-serif;
    font-weight: 300;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    font-size: 12px;
    color: ${theme.gold};
    margin: 64px 0 28px;
    border-top: 1px solid rgba(184, 149, 90, 0.2);
    padding-top: 28px;
  }
  .process-author-bio {
    font-family: 'Cormorant Garamond', serif;
    font-size: 16px;
    color: ${theme.textMuted};
    line-height: 1.7;
    font-style: italic;
    margin-top: 64px;
    padding-top: 28px;
    border-top: 1px solid rgba(184, 149, 90, 0.2);
  }
  @media (max-width: 768px) {
    .process-card {
      padding: 36px 24px;
    }
  }
  @media (max-width: 600px) {
    .process-wrapper {
      padding: 24px 16px;
    }
    .process-card {
      padding: 28px 18px;
      border: none;
      outline: none;
      background: transparent;
      box-shadow: none;
    }
    .process-card::before {
      display: none;
    }
    .process-title {
      font-size: 28px;
    }
    .process-heading {
      margin: 48px 0 20px;
      padding-top: 20px;
    }
    .process-body {
      font-size: 17px;
      line-height: 1.8;
    }
    .process-body p {
      text-align: left;
    }
    .process-pullquote {
      font-size: 19px;
      padding: 0 20px;
      margin: 32px 0;
    }
    .process-author-bio {
      font-size: 15px;
      margin-top: 48px;
      padding-top: 20px;
    }
    .audio-player-container {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      padding: 14px 16px;
    }
    .audio-player-left {
      min-width: 0;
    }
    .audio-player-right {
      justify-content: flex-start;
      margin-top: -4px;
    }
  }
`;

const essayParagraphs = [
  "Mainstream finance theory is built on mathematical elegance. Clean models, closed systems, equilibrium states. It is intellectually beautiful - and persistently wrong about the world it claims to describe.",
  "The models are maps. Useful as torchlight in a dark room. But the terrain is messier, more human, more surprising than any equation can hold. Markets are not populated by rational agents optimising utility functions. They are populated by people - making plans, revising expectations, acting on incomplete information, and occasionally getting things badly wrong together.",
  "Austrian economics gave me the terrain. Not the map.",
  "What drew me to it was not just its conclusions but its character. Mainstream economics begins with market failure - a convenient premise that justifies intervention. Austrian economics begins with human action - the irreducible fact that individuals choose, that choices have consequences across time, and that no central authority can replicate what prices do naturally. It felt independent. Unmanipulated. Built from first principles rather than policy preferences. Closer in spirit to how Buffett and Munger actually think about businesses than anything in a standard economics curriculum.",
  "What Three Thinkers Gave Me.",
  "Mises taught me to find the root node of any argument. If a line of thinking is built on a faulty foundation, it will eventually crack - regardless of how sophisticated the superstructure above it appears. He also gave me the concept of time preference: that saving is deferred consumption, that the length of the production structure is directly linked to genuine saving, and that credit created without saving is not capital - it is a distortion wearing capital's clothes.",
  "Hayek gave me systems thinking. His insight about prices is one of the most underappreciated ideas in all of economics: that a price is not just a number - it is a compressed signal carrying the dispersed knowledge of millions of individuals, none of whom could articulate what they collectively know. When prices are interfered with, that signal is corrupted. Decisions that would have been corrected by the market proceed uncorrected. The damage is invisible until it is not.",
  "Lachmann gave me radical subjectivism - and a certain intellectual humility about what markets can and cannot do. Where Hayek sought meaningful order emerging from complexity, Lachmann saw order as momentary, fragile, and perpetually threatened by the kaleidoscopic nature of human plans. Capital is not a homogeneous fund. It is a structure of heterogeneous goods whose value depends entirely on context, on the plans of the entrepreneurs who assemble them, and on the consumer preferences that may shift without warning. Smooth market functioning is not the norm. It is the exception - and a temporary one.",
  "When It Clicked.",
  "The Austrian framework does not just explain how things work. It explains how things go wrong - collectively, systematically, and with a logic that conventional analysis cannot see because it is looking at the wrong variables.",
  "Low interest rates are not stimulus. They are a signal - a false one - that savings exist to fund long production structures when they do not. The boom that follows is not prosperity. It is a misallocation of real resources into projects that only appeared viable because the price of time was artificially suppressed. The bust that follows is not a failure of markets. It is the market correcting the distortion - resetting, liquidating malinvestment, restoring the alignment between real savings and real production.",
  "Real savings act like physical gravity. You can ignore gravity for a while. But it does not stop being true.",
  "What This Means for India.",
  "India is a genuine growth market. The entrepreneurial energy is real. The demographic foundation is real. But political realism has made choices that prevent capitalism from working to its fullest potential.",
  "Malinvestment risks run high - particularly in government balance sheets, where capital allocation decisions are made without the discipline of price signals or the accountability of loss. Credit suppression over decades has distorted savings behaviour. Large institutions enjoy preferential access to liquidity that smaller enterprises do not. High returns on equity in certain sectors demand scrutiny - not celebration - because their sustainability depends on whether they reflect genuine competitive advantage or regulatory shelter.",
  "Understanding the Indian economy requires peeling the layers. It requires fine-grain analysis of what is driving growth in a given sector, who has access to what capital, how exposed a business is to macro volatility, and how susceptible the wider economy is to the sudden reversals that external account pressures can trigger even when domestic conditions appear controlled.",
  "Skepticism toward any single growth narrative about India is not a counsel of ignorance. It is a rational response to macro risks that the Austrian framework helps identify and respect.",
  "Why These Tools Exist.",
  "We are steeped in Keynesianism - a framework developed as a special case response to depression-era conditions that has since acquired the status of natural law. It is taught as economics. It is not economics. It is one contested interpretation of a specific historical moment, elevated by institutional convenience.",
  "The real nature of markets is not taught. The impossibility of rational calculation without prices is not taught. The relationship between time preference, saving, and the structure of production is not taught. The Garrison Triangle is not on any syllabus that produces the economists and policymakers shaping decisions today.",
  "These tools exist to change that - slowly, for whoever is willing to engage seriously. For students of economics. For anyone who senses that something is missing from their economics education but cannot name it. For future generations who will make decisions in a world that runs on these concepts whether or not they are taught in classrooms.",
  "The real world does not run on equilibrium models. It never did.",
  "A Final Word.",
  "Genuine understanding of how economies actually function - how prices coordinate action, how credit expansion distorts the structure of production, how capital is not a homogeneous blob but a fragile, purposeful arrangement - is not acquired through sound bites.",
  "It is built through reading, reflecting, and testing these ideas against the world as it actually behaves.",
  "There is no shortcut to it. And there is no substitute for it."
];

function ProcessPage() {
  const [scrollPercent, setScrollPercent] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackProgress, setPlaybackProgress] = useState(0);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [currentParagraphIndex, setCurrentParagraphIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [copied, setCopied] = useState(false);
  
  const isSelfCancelled = useRef(false);
  const timerRef = useRef(null);
  
  const fullTextLength = essayParagraphs.join(" ").length;
  const totalDuration = Math.round(fullTextLength / 14); // Estimated 14 chars/sec
  const paragraphOffsets = useRef([]);

  // Pre-calculate character offsets for accurate timeline scrubbing
  useEffect(() => {
    let offset = 0;
    paragraphOffsets.current = essayParagraphs.map(p => {
      const start = offset;
      offset += p.length + 1; // including space character between paragraphs
      return { start, length: p.length };
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Why Austrian - Austrian Process";

    // Pre-trigger voice loading for speechSynthesis
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.getVoices();
      if (window.speechSynthesis.onvoiceschanged !== undefined) {
        window.speechSynthesis.onvoiceschanged = () => {
          window.speechSynthesis.getVoices();
        };
      }
    }

    // Set dynamic meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    const previousDesc = metaDescription ? metaDescription.getAttribute('content') : '';
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        "Why Austrian economics and not mainstream finance theory - an explainer of the Garrison Triangle, sound money, and capital structure."
      );
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    const previousCanonical = canonicalLink ? canonicalLink.getAttribute('href') : '';
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://www.austrianprocess.com/process');
    }

    // Scroll progress handler
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const pct = maxScroll > 0 ? (scrolled / maxScroll) * 100 : 0;
      setScrollPercent(pct);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      // Restore previous description on unmount
      if (metaDescription && previousDesc) {
        metaDescription.setAttribute('content', previousDesc);
      }
      if (canonicalLink && previousCanonical) {
        canonicalLink.setAttribute('href', previousCanonical);
      }
      window.removeEventListener('scroll', handleScroll);
      
      // Stop speech synthesis on unmount
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        isSelfCancelled.current = true;
        window.speechSynthesis.cancel();
      }
    };
  }, []);

  // Text-To-Speech Queue execution
  const speakParagraph = (index) => {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;

    isSelfCancelled.current = true;
    window.speechSynthesis.cancel();
    isSelfCancelled.current = false;

    if (index >= essayParagraphs.length) {
      setIsPlaying(false);
      setCurrentParagraphIndex(0);
      setPlaybackProgress(0);
      setElapsedTime(0);
      return;
    }

    const textToSpeak = essayParagraphs[index];
    const utterance = new SpeechSynthesisUtterance(textToSpeak);

    // Voice Selection
    const voices = window.speechSynthesis.getVoices();
    
    // Select the best matching voice (prioritize en-GB male, then en-US male, etc.)
    const maleNames = [
      'male', 'george', 'daniel', 'arthur', 'oliver', 'ryan', 'thomas', 
      'harry', 'brian', 'peter', 'david', 'guy', 'andrew', 'rishi', 
      'ravi', 'james', 'charles', 'william', 'alex', 'fred', 'aaron', 
      'gordon', 'nicky', 'mark', 'mick', 'paul', 'sam', 'tom', 
      'john', 'jack', 'joshua', 'ben', 'robert', 'karan',
      'gregory', 'ian', 'kurt', 'pete', 'karl', 'steve', 'siri voice 2', 
      'siri voice 4', 'x-iom', 'x-rgf', 'x-jcd', 'x-tpf', 'x-rjs', 
      'x-fis', 'x-gdo', 'x-ahp', 'x-gdf'
    ];
    const femaleNames = [
      'female', 'hazel', 'susan', 'zira', 'heera', 'kate', 'serena', 
      'samantha', 'victoria', 'karen', 'moira', 'tessa', 'veena', 
      'lisa', 'zoe', 'chloe', 'siri voice 1', 'siri voice 3',
      'x-sfg', 'x-tfd', 'x-hzz', 'x-gba', 'x-wod', 'x-hsp', 'x-cne', 'x-ene'
    ];

    let selectedVoice = null;
    let highestScore = -1000;

    for (let i = 0; i < voices.length; i++) {
      const v = voices[i];
      let score = 0;
      const nameLower = v.name.toLowerCase();
      const langLower = v.lang.toLowerCase();

      // Language Match
      if (langLower.startsWith('en-gb')) {
        score += 100;
      } else if (langLower.startsWith('en-us')) {
        score += 50;
      } else if (langLower.startsWith('en-in') || langLower.startsWith('en-au') || langLower.startsWith('en-ca')) {
        score += 30;
      } else if (langLower.startsWith('en-')) {
        score += 20;
      } else {
        score -= 100; // Penalize non-English voices
      }

      // Gender Match (prefer male for baritone tone)
      const isMale = maleNames.some(name => nameLower.includes(name));
      const isFemale = femaleNames.some(name => nameLower.includes(name));

      if (isMale) {
        score += 150;
      }
      if (isFemale) {
        score -= 100;
      }

      // Quality indicator
      if (nameLower.includes('natural') || nameLower.includes('neural') || nameLower.includes('multilingual')) {
        score += 10;
      }

      if (v.default) {
        score += 5;
      }

      if (score > highestScore) {
        highestScore = score;
        selectedVoice = v;
      }
    }

    const voice = selectedVoice || voices[0];

    if (voice) {
      utterance.voice = voice;
    }

    // Speeds rate for natural, fluent pace (reduced by 15% from 1.375 to 1.17)
    utterance.rate = 1.17;
    
    // Pitch-shift down (e.g. 0.85) to create a deeper, baritone, authoritative tone
    utterance.pitch = 0.85;

    utterance.onend = () => {
      if (isSelfCancelled.current) return;
      const nextIndex = index + 1;
      setCurrentParagraphIndex(nextIndex);
      speakParagraph(nextIndex);
    };

    utterance.onerror = (e) => {
      console.error("SpeechSynthesis error:", e);
      if (!isSelfCancelled.current) {
        setIsPlaying(false);
      }
    };

    window.speechSynthesis.speak(utterance);
  };

  const handlePlayToggle = () => {
    if (typeof window === 'undefined' || !window.speechSynthesis) {
      alert("Text-to-speech is not supported in this browser.");
      return;
    }

    if (isPlaying) {
      isSelfCancelled.current = true;
      window.speechSynthesis.cancel();
      setIsPlaying(false);
    } else {
      setIsPlaying(true);
      speakParagraph(currentParagraphIndex);
    }
  };

  const handleSliderChange = (e) => {
    setIsDragging(true);
    const val = parseFloat(e.target.value);
    setPlaybackProgress(val);

    const targetOffset = (val / 100) * fullTextLength;
    let targetParagraph = 0;
    
    for (let i = 0; i < paragraphOffsets.current.length; i++) {
      const p = paragraphOffsets.current[i];
      if (targetOffset >= p.start && targetOffset <= p.start + p.length) {
        targetParagraph = i;
        break;
      }
      if (i < paragraphOffsets.current.length - 1 && targetOffset > p.start + p.length && targetOffset < paragraphOffsets.current[i + 1].start) {
        targetParagraph = i;
        break;
      }
    }

    setCurrentParagraphIndex(targetParagraph);
    setElapsedTime(Math.floor((val / 100) * totalDuration));
  };

  const handleSliderRelease = () => {
    setIsDragging(false);
    if (isPlaying) {
      speakParagraph(currentParagraphIndex);
    } else {
      isSelfCancelled.current = true;
      window.speechSynthesis.cancel();
      isSelfCancelled.current = false;
    }
  };

  // Sync timers and playback progress bar
  useEffect(() => {
    if (isPlaying && !isDragging) {
      timerRef.current = setInterval(() => {
        setElapsedTime(prev => {
          const nextTime = prev + 1;
          if (nextTime >= totalDuration) {
            return totalDuration;
          }

          // Calculate approximate progress percentage based on paragraph start offset
          const currentParaOffset = paragraphOffsets.current[currentParagraphIndex]?.start || 0;
          const currentParaProgress = (currentParaOffset / (fullTextLength || 1)) * 100;
          
          const timeProgress = (nextTime / totalDuration) * 100;
          // Interpolate progress smoothly between actual paragraph updates
          setPlaybackProgress(Math.min(100, Math.max(currentParaProgress, timeProgress)));

          return nextTime;
        });
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isPlaying, isDragging, currentParagraphIndex, fullTextLength, totalDuration]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div className="process-wrapper">
      <style>{PROCESS_CSS}</style>

      {/* Top sticky scroll progress bar */}
      <div className="scroll-progress-container">
        <div className="scroll-progress-bar" style={{ width: `${scrollPercent}%` }}></div>
      </div>

      <div className="process-breadcrumb" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <Link to="/" className="breadcrumb-link">Austrian Process</Link>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">Why Austrian</span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          textTransform: 'none',
          letterSpacing: 'normal',
          flexShrink: 0,
        }}>
          {/* Twitter Button */}
          <a 
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent('Why Austrian - Austrian Process')}`}
            target="_blank" 
            rel="noopener noreferrer"
            title="Share on X"
            style={{
              color: theme.textMuted,
              transition: 'color 0.2s',
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = theme.gold}
            onMouseLeave={(e) => e.currentTarget.style.color = theme.textMuted}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>

          {/* LinkedIn Button */}
          <a 
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
            target="_blank" 
            rel="noopener noreferrer"
            title="Share on LinkedIn"
            style={{
              color: theme.textMuted,
              transition: 'color 0.2s',
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = theme.gold}
            onMouseLeave={(e) => e.currentTarget.style.color = theme.textMuted}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>

          {/* Copy Link Button */}
          <button 
            onClick={(e) => {
              e.preventDefault();
              navigator.clipboard.writeText(window.location.href).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              });
            }}
            title="Copy link"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              color: copied ? theme.gold : theme.textMuted,
              transition: 'color 0.2s',
              display: 'flex',
              alignItems: 'center',
            }}
            onMouseEnter={(e) => { if(!copied) e.currentTarget.style.color = theme.gold }}
            onMouseLeave={(e) => { if(!copied) e.currentTarget.style.color = theme.textMuted }}
          >
            {copied ? (
              <span style={{
                fontFamily: "'Josefin Sans', sans-serif",
                fontSize: '12px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginRight: '4px',
              }}>Copied</span>
            ) : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Double Bordered Paper Card Wrap */}
      <div className="process-card">
        <div className="process-header">
          <div className="process-meta">
            <span className="meta-item">6 min read</span>
          </div>
          <h1 className="process-title">Why Austrian - A Personal View</h1>
        </div>

        {/* Narrated Audio Player Widget */}
        <div className="audio-player-container">
          <div className="audio-player-left">
            <button 
              className={`audio-play-button ${isPlaying ? 'playing' : ''}`}
              onClick={handlePlayToggle}
              aria-label={isPlaying ? 'Pause narration' : 'Play narration'}
            >
              {isPlaying ? (
                <svg className="audio-play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
                </svg>
              ) : (
                <svg className="audio-play-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              )}
            </button>
            <div className="audio-player-info">
              <span className="audio-player-title">Listen to Article</span>
              <span className="audio-player-narrator">AI Voice Narration</span>
            </div>
          </div>
          
          <div className="audio-player-center">
            <div className="audio-timeline-wrapper">
              <input 
                type="range" 
                min="0" 
                max="100" 
                step="0.1" 
                value={playbackProgress} 
                onChange={handleSliderChange} 
                onMouseUp={handleSliderRelease}
                onTouchEnd={handleSliderRelease}
                onKeyUp={handleSliderRelease}
                className="audio-timeline-slider"
                aria-label="Audio playback progress"
              />
              <div className="audio-timeline-fill" style={{ width: `${playbackProgress}%` }}></div>
            </div>
          </div>
          
          <div className="audio-player-right">
            <span className="audio-time">{formatTime(elapsedTime)}</span>
            <span className="audio-time-separator">/</span>
            <span className="audio-time">{formatTime(totalDuration)}</span>
          </div>
        </div>

        <div className="process-body">
          <p>
            Mainstream finance theory is built on mathematical elegance. Clean models, closed systems, equilibrium states. It is intellectually beautiful - and persistently wrong about the world it claims to describe.
          </p>
          
          <blockquote className="process-pullquote">
            Mainstream finance theory is built on mathematical elegance. Clean models, closed systems, equilibrium states. It is intellectually beautiful - and persistently wrong.
          </blockquote>

          <p>
            The models are maps. Useful as torchlight in a dark room. But the terrain is messier, more human, more surprising than any equation can hold. Markets are not populated by rational agents optimising utility functions. They are populated by people - making plans, revising expectations, acting on incomplete information, and occasionally getting things badly wrong together.
          </p>
          <p>
            Austrian economics gave me the terrain. Not the map.
          </p>
          <p>
            What drew me to it was not just its conclusions but its character. Mainstream economics begins with market failure - a convenient premise that justifies intervention. Austrian economics begins with human action - the irreducible fact that individuals choose, that choices have consequences across time, and that no central authority can replicate what prices do naturally. It felt independent. Unmanipulated. Built from first principles rather than policy preferences. Closer in spirit to how Buffett and Munger actually think about businesses than anything in a standard economics curriculum.
          </p>

          <h2 className="process-heading">What Three Thinkers Gave Me</h2>
          <p>
            Mises taught me to find the root node of any argument. If a line of thinking is built on a faulty foundation, it will eventually crack - regardless of how sophisticated the superstructure above it appears. He also gave me the concept of time preference: that saving is deferred consumption, that the length of the production structure is directly linked to genuine saving, and that credit created without saving is not capital - it is a distortion wearing capital's clothes.
          </p>
          <p>
            Hayek gave me systems thinking. His insight about prices is one of the most underappreciated ideas in all of economics: that a price is not just a number - it is a compressed signal carrying the dispersed knowledge of millions of individuals, none of whom could articulate what they collectively know. When prices are interfered with, that signal is corrupted. Decisions that would have been corrected by the market proceed uncorrected. The damage is invisible until it is not.
          </p>
          <p>
            Lachmann gave me radical subjectivism - and a certain intellectual humility about what markets can and cannot do. Where Hayek sought meaningful order emerging from complexity, Lachmann saw order as momentary, fragile, and perpetually threatened by the kaleidoscopic nature of human plans. Capital is not a homogeneous fund. It is a structure of heterogeneous goods whose value depends entirely on context, on the plans of the entrepreneurs who assemble them, and on the consumer preferences that may shift without warning. Smooth market functioning is not the norm. It is the exception - and a temporary one.
          </p>

          <h2 className="process-heading">When It Clicked</h2>
          <p>
            The Austrian framework does not just explain how things work. It explains how things go wrong - collectively, systematically, and with a logic that conventional analysis cannot see because it is looking at the wrong variables.
          </p>
          <p>
            Low interest rates are not stimulus. They are a signal - a false one - that savings exist to fund long production structures when they do not. The boom that follows is not prosperity. It is a misallocation of real resources into projects that only appeared viable because the price of time was artificially suppressed. The bust that follows is not a failure of markets. It is the market correcting the distortion - resetting, liquidating malinvestment, restoring the alignment between real savings and real production.
          </p>

          <blockquote className="process-pullquote">
            Real savings act like physical gravity. You can ignore gravity for a while. But it does not stop being true.
          </blockquote>

          <p>
            Real savings act like physical gravity. You can ignore gravity for a while. But it does not stop being true.
          </p>

          <h2 className="process-heading">What This Means for India</h2>
          <p>
            India is a genuine growth market. The entrepreneurial energy is real. The demographic foundation is real. But political realism has made choices that prevent capitalism from working to its fullest potential.
          </p>
          <p>
            Malinvestment risks run high - particularly in government balance sheets, where capital allocation decisions are made without the discipline of price signals or the accountability of loss. Credit suppression over decades has distorted savings behaviour. Large institutions enjoy preferential access to liquidity that smaller enterprises do not. High returns on equity in certain sectors demand scrutiny - not celebration - because their sustainability depends on whether they reflect genuine competitive advantage or regulatory shelter.
          </p>
          <p>
            Understanding the Indian economy requires peeling the layers. It requires fine-grain analysis of what is driving growth in a given sector, who has access to what capital, how exposed a business is to macro volatility, and how susceptible the wider economy is to the sudden reversals that external account pressures can trigger even when domestic conditions appear controlled.
          </p>
          <p>
            Skepticism toward any single growth narrative about India is not a counsel of ignorance. It is a rational response to macro risks that the Austrian framework helps identify and respect.
          </p>

          <h2 className="process-heading">Why These Tools Exist</h2>
          <p>
            We are steeped in Keynesianism - a framework developed as a special case response to depression-era conditions that has since acquired the status of natural law. It is taught as economics. It is not economics. It is one contested interpretation of a specific historical moment, elevated by institutional convenience.
          </p>
          <p>
            The real nature of markets is not taught. The impossibility of rational calculation without prices is not taught. The relationship between time preference, saving, and the structure of production is not taught. The Garrison Triangle is not on any syllabus that produces the economists and policymakers shaping decisions today.
          </p>
          <p>
            These tools exist to change that - slowly, for whoever is willing to engage seriously. For students of economics. For anyone who senses that something is missing from their economics education but cannot name it. For future generations who will make decisions in a world that runs on these concepts whether or not they are taught in classrooms.
          </p>
          <p>
            The real world does not run on equilibrium models. It never did.
          </p>

          <h2 className="process-heading">A Final Word</h2>
          <p>
            Genuine understanding of how economies actually function - how prices coordinate action, how credit expansion distorts the structure of production, how capital is not a homogeneous blob but a fragile, purposeful arrangement - is not acquired through sound bites.
          </p>
          <p>
            It is built through reading, reflecting, and testing these ideas against the world as it actually behaves.
          </p>
          <p>
            There is no shortcut to it. And there is no substitute for it.
          </p>

          <div className="process-author-bio">
            Written by Ashok, CA, CFA. This site is a personal study project, not investment advice or a promotional channel. Separately, I run <a href="https://www.mannheimcapital.com" target="_blank" rel="noopener noreferrer" style={{ color: theme.gold }}>Mannheim Capital</a>, an investment practice informed by this thinking - but built independently of it.
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessPage;
